import { useState, useEffect } from 'react'

/**
 * Hook using `useEffect`, but only runs until a condition is met
 * 
 * @param {Function} fn Function to run; must return true to stop further runs
 * @param {Array<*>} dependencies List of dependencies to pass to `useEffect`
 */
const useEffectOnce = (fn, dependencies) => {
    
    const [hasRun, setHasRun] = useState(false)
    
    useEffect(() => {
        
        if (hasRun) return
        
        const result = fn()
        
        if (result !== true && result !== false)
            throw new Error('useEffectOnce: function must return true or false')
        
        if (fn() === true)
            setHasRun(true)
        
    }, [fn, hasRun, ...dependencies])
    
}

export default useEffectOnce
